import api from './api';

export interface PlatformPlanInfo {
  planId?: string;
  slug: string;
  name: string;
  billingType: string;
  status?: string;
  isCurrent: boolean;
  monthlyAmountCents?: number;
  currencyCode: string;
}

export interface EarningsSummary {
  currencyCode: string;
  grossCentsMonthToDate: number;
  commissionCents: number;
  netEarningsCents: number;
  commissionRate: number;
  activeSubscriptions: number;
  pendingLessonValueCents: number;
}

export interface StudentPaymentRow {
  subscriptionId: string;
  studentId: string;
  studentName: string;
  packageName?: string;
  priceCents: number;
  currencyCode: string;
  status: string;
  cancelAtPeriodEnd: boolean;
  currentPeriodEnd?: string;
  netAfterFeesCents: number;
}

export interface TeacherPaymentsOverview {
  currentPlatformPlan: PlatformPlanInfo;
  availablePlans: PlatformPlanInfo[];
  earnings: EarningsSummary;
  studentPayments: StudentPaymentRow[];
}

export const teacherBillingService = {
  async getPaymentsOverview(): Promise<TeacherPaymentsOverview> {
    const res = await api.get<TeacherPaymentsOverview>('/billing/teacher/payments-overview');
    return res.data;
  },

  async startPlatformCheckout(planSlug: string, redirectUrl: string): Promise<{ checkoutUrl: string }> {
    const res = await api.post<{ checkoutUrl?: string; url?: string }>('/billing/teacher/checkout', {
      planSlug,
      redirectUrl,
    });
    const url = res.data.checkoutUrl ?? res.data.url;
    if (!url) throw new Error('No checkout URL returned');
    return { checkoutUrl: url };
  },

  async getPlatformPlans() {
    const res = await api.get('/billing/teacher/platform-plans');
    return res.data;
  },

  async getPlatformCustomerLinks(): Promise<{
    customerPortalUrl?: string;
    updatePaymentMethodUrl?: string;
  }> {
    const res = await api.get<{
      customerPortalUrl?: string;
      updatePaymentMethodUrl?: string;
    }>('/billing/teacher/platform-subscription/customer-links');
    return res.data;
  },
};
